import IndexBlockPlanPeacePanel from './IndexBlockPlanPeacePanel';

export default IndexBlockPlanPeacePanel;
